export function getPath(source: unknown, path: string): unknown {
  return path.split(".").reduce<unknown>((value, segment) => {
    if (value == null) return undefined;
    return (value as Record<string, unknown>)[segment];
  }, source);
}

export function setPath<T>(source: T, path: string, value: unknown): T {
  const clone = structuredClone(source);
  const segments = path.split(".");
  let cursor = clone as Record<string, unknown>;
  for (let index = 0; index < segments.length - 1; index += 1) {
    const segment = segments[index];
    const next = segments[index + 1];
    if (cursor[segment] == null) cursor[segment] = /^\d+$/.test(next) ? [] : {};
    cursor = cursor[segment] as Record<string, unknown>;
  }
  cursor[segments[segments.length - 1]] = value;
  return clone;
}
